var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrdersActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 5.72323C8.19995 5.27246 7.16076 5.01953 6.0625 5.01953C4.96424 5.01953 3.92505 5.27246 3 5.72323V14.4732C3.92505 14.0225 4.96424 13.7695 6.0625 13.7695C7.52253 13.7695 8.87816 14.2165 10 14.9811C11.1218 14.2165 12.4775 13.7695 13.9375 13.7695C15.0358 13.7695 16.075 14.0225 17 14.4732V5.72323C16.075 5.27246 15.0358 5.01953 13.9375 5.01953C12.8392 5.01953 11.8 5.27246 10.875 5.72323V12.0195C10.875 12.5028 10.4832 12.8945 10 12.8945C9.51675 12.8945 9.125 12.5028 9.125 12.0195V5.72323Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrdersActive);
export default __webpack_public_path__ + "static/media/orders-active.52c9f5d19bb99bf199aea51258f142de.svg";
export { ForwardRef as ReactComponent };